import React, { useState } from 'react';
import color from '../../constants/Colors';
import { SvgAssets } from '../../assets/icons/iconSvg';

const ValorCriterio = (props) => {
    let ACTIVE = props.active;
    let CONTAINER_STYLE = props.containerStyle;
    let VALUE = props.value;
    return (
        <div className="valor_criterio" style={Object.assign(CONTAINER_STYLE,{backgroundColor: ACTIVE ? color.naranjaClaro : color.celesteClaro})}>
            <SvgAssets icon="icon-foco-2" width="15" height="20" fill={ACTIVE ? color.naranja : color.grisMedio}/>
            <span style={{color: ACTIVE ? color.naranja : color.grisMedio}}>{VALUE}</span>
        </div>
    );
}

export default ValorCriterio;
